<div>
    <div class="question-body">
        <div class="question-text">{{hasPhysicianLabel}}</div>
        <div class="container-fluid">
            <mat-radio-group [(ngModel)]="hasPhysician">
                <mat-radio-button class="d-block" (click)="hasPhysicianAnswer(true)" [disabled]="summaryMode"
                    [value]="true" [attr.data-test-value]="true">Yes</mat-radio-button>
                <mat-radio-button class="d-block" (click)="hasPhysicianAnswer(false)" [disabled]="summaryMode"
                    [value]="false" [attr.data-test-value]="false">No</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>
<div *ngIf="hasPhysician" style="margin: 20px">
    <form #form="ngForm" *ngFor="let physicianValue of getPhysicians(); index as $index;">
        <div class="row">
            <div class="col-4" *ngIf="$index == 0 && !primary">
                <span><u>Physician Details</u></span><br /><br />
                <span>Please fill in physician details for <u>{{name}}</u> disclosure.</span>
            </div>
            <div class="col-4" *ngIf="$index == 0 && primary">
                <span><u>Primary Care Details</u></span><br /><br />
                <span>Please fill in your primary physician or medical center details.</span>
            </div>
            <div class="offset-4" *ngIf="$index > 0"></div>
            <div class="col-8">
                <div class="row mb-2">
                    <div class="col-12">
                        <input class="form-control" name="{{name}}_physician_name" type="text"
                            placeholder="Name / Surname" [(ngModel)]="physicianValue.name" [disabled]="summaryMode"
                            required />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12">
                        <input class="form-control" name="{{name}}_physician_speciality" type="text"
                            placeholder="Speciality" [disabled]="summaryMode" [(ngModel)]="physicianValue.speciality" />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12">
                        <input class="form-control" name="{{name}}_physician_address1" type="text"
                            placeholder="Address line (1)" [disabled]="summaryMode"
                            [(ngModel)]="physicianValue.addressLine1" />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12">
                        <input class="form-control" name="{{name}}_physician_address2" type="text"
                            placeholder="Address line (2)" [disabled]="summaryMode"
                            [(ngModel)]="physicianValue.addressLine2" />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12" *ngIf="_.isEmpty(countryStatesMap.get(physicianValue))">
                        <input class="form-control" name="{{name}}_physician_state" type="text" placeholder="State"
                            [disabled]="summaryMode" [(ngModel)]="physicianValue.stateString" required />
                    </div>
                    <div class="col-12 pl-0 pr-0" *ngIf="!_.isEmpty(countryStatesMap.get(physicianValue))">
                        <jhi-select-input [name]="name + '_physician_state'"
                            [options]="countryStatesMap.get(physicianValue)" [(value)]="physicianValue.state.code"
                            [valueMapper]="mapToOptionValueFromListItems" [labelMapper]="mapToOptionLabelFromListItems"
                            [summaryMode]="summaryMode">
                        </jhi-select-input>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-5">
                        <input class="form-control" name="{{name}}_physician_zip" type="text" placeholder="Zip"
                            [disabled]="summaryMode" [(ngModel)]="physicianValue.zip" />
                    </div>
                    <div class="col-7">
                        <input class="form-control" name="{{name}}_physician_city" type="text" placeholder="City"
                            [disabled]="summaryMode" [(ngModel)]="physicianValue.city" required />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12" *ngIf="countries == null || countries.listItems.length == 0">
                        <input class="form-control" name="{{name}}_physician_country" type="text" placeholder="Country"
                            *ngIf="countries == null" [disabled]="summaryMode" [(ngModel)]="physicianValue.country.code"
                            required />
                    </div>
                    <div class="col-12 pl-0 pr-0" *ngIf="countries != null &&  countries.listItems.length > 0">
                        <jhi-select-input [name]="name + '_physician_country'" [options]="countries.listItems"
                            [(value)]="physicianValue.country.code" [valueMapper]="mapToOptionValueFromListItems"
                            [labelMapper]="mapToOptionLabelFromListItems"
                            (action)="fetchStatesForCountry(physicianValue)" [summaryMode]="summaryMode">
                        </jhi-select-input>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6">
                        <input class="form-control" name="{{name}}_physician_phone" type="text" placeholder="Phone"
                            [disabled]="summaryMode" [(ngModel)]="physicianValue.phone" />
                    </div>
                    <div class="col-6">
                        <input class="form-control" name="{{name}}_physician_fax" type="text" placeholder="Fax"
                            [disabled]="summaryMode" [(ngModel)]="physicianValue.fax" />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12">
                        <input class="form-control" name="{{name}}_physician_email" type="text" placeholder="E-mail"
                            [disabled]="summaryMode" [(ngModel)]="physicianValue.email" />
                    </div>
                </div>
                <div class="row mb-2" *ngIf="!primary">
                    <div class="col-7">When did you last visit this physician for this condition?</div>
                    <div class="col-5">
                        <div class="row">
                            <div class="col-4">
                                <input class="form-control" name="{{name}}_physician_last_check_month" type="text"
                                    placeholder="mm" [(ngModel)]="disclosurePhysiciansValue[$index].lastVisitMonth"
                                    [disabled]="summaryMode" minlength="2" maxlength="2" required />
                            </div>
                            <div class="col-8">
                                <input class="form-control" name="{{name}}_physician_last_check_year" type="text"
                                    placeholder="yyyy" [(ngModel)]="disclosurePhysiciansValue[$index].lastVisitYear"
                                    [disabled]="summaryMode" minlength="4" maxlength="4" required />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!summaryMode" style="padding-bottom: 20px">
            <div class="offset-4"></div>
            <div class="col-8">
                <div class="pt-4 flex" style="justify-content: flex-end;align-items: center;">
                    <mrs-btn-primary buttonLabel="Submit" buttonId="goHomeBtn" (onClick)="submit($index)"
                        [disabled]="!form.valid"></mrs-btn-primary>

                    <mrs-btn-tertiary buttonLabel="Clear" buttonId="cancelButton"
                        (onClick)="clear($index)">Cancel</mrs-btn-tertiary>

                </div>
            </div>
        </div>
    </form>
</div>